import React, { FC } from "react"
import {
  VictoryAxis,
  VictoryChart,
  VictoryContainer,
  VictoryLine,
  VictoryScatter,
  VictoryTooltip,
  VictoryLabel,
} from "victory"
import { colors } from "../../utils/theme"
import { ChartDataPoints } from "../../utils/types"
import ChartTooltip from "../atoms/ChartTooltip"
import {
  TREND_CHART,
  chartAxisLabelStyle,
  chartTickLabelStyle,
} from "./charts/chartTypography"

const chartWrapStyle: React.CSSProperties = {
  marginTop: 16,
  width: "100%",
  maxWidth: "100%",
  minWidth: 0,
  overflow: "hidden",
}

const SocialMediaChart: FC<{
  data: ChartDataPoints[][]
  categories: string[]
}> = ({ data, categories }) => (
  <div style={chartWrapStyle}>
    <VictoryChart
      height={TREND_CHART.height}
      width={TREND_CHART.width}
      domainPadding={{ x: [0, 48] }}
      padding={{ top: 16, bottom: 44, left: 67, right: 4 }}
      containerComponent={
        <VictoryContainer
          responsive
          style={{ width: "100%", height: "auto" }}
        />
      }
    >
      <VictoryAxis
        orientation="top"
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="right"
        dependentAxis={true}
        tickComponent={<></>}
        tickLabelComponent={<></>}
        style={{
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="bottom"
        offsetY={44}
        tickFormat={(tick, index) => (index % 2 !== 0 ? tick : "")}
        style={{
          tickLabels: chartTickLabelStyle,
          axis: { stroke: colors.neutral.clay },
        }}
      />
      <VictoryAxis
        orientation="left"
        dependentAxis={true}
        tickValues={[0, 1250, 2500, 3750, 5000]}
        label="Number of Words"
        axisLabelComponent={<VictoryLabel angle={-90} />}
        style={{
          tickLabels: chartTickLabelStyle,
          axisLabel: chartAxisLabelStyle,
          grid: { stroke: colors.neutral.clay },
          axis: { stroke: colors.neutral.clay },
        }}
      />

      {data.map((datum, index) => (
        <VictoryLine
          key={index}
          data={datum.map(({ x, y }) => ({ x, y }))}
          categories={{
            x: categories,
          }}
          style={{
            data: {
              stroke: datum[0]?.darkColor,
              strokeWidth: 2,
            },
          }}
        />
      ))}

      {data.map((datum, index) => (
        <VictoryScatter
          key={index}
          data={datum}
          symbol="circle"
          size={6}
          style={{
            data: {
              stroke: datum[0]?.darkColor,
              strokeWidth: 2,
              fill: datum[0]?.lightColor,
            },
          }}
          labelComponent={
            <VictoryTooltip
              flyoutComponent={
                <ChartTooltip
                  width={154}
                  crosshair={{
                    chartHeight: 265,
                    paddingTop: 16,
                    paddingBottom: 44,
                  }}
                />
              }
            />
          }
        />
      ))}
    </VictoryChart>
  </div>
)

export default SocialMediaChart
